<mat-card class="welcome-card mat-typography">
	<mat-card-header class="p-05">
		<div class="header-content">
			<div class="icon-container">
				<lucide-angular name="user" class="custom-icon"></lucide-angular>
			</div>
			<mat-card-title>
				<app-title
					[title]="'¡Hola ' + userName + '!'"
					headerType="3"
				></app-title>
				<mat-card-subtitle>Sistema MRV - {{ userCompany }}</mat-card-subtitle>
			</mat-card-title>
		</div>
	</mat-card-header>

	<mat-card-content class="card-content mt-1">
		<mat-card-subtitle
			>Has ingresado exitosamente al Sistema de Monitoreo, Reporte y
			Verificación (MRV). Todas las funcionalidades están disponibles según los
			permisos asignados a tu perfil.</mat-card-subtitle
		>
	</mat-card-content>
</mat-card>
